import { Action } from '@ngrx/store';

export const SYNC_SELECTED_COMPANY_STATE = '[Company] Sync Selected Company State';
export const SELECT_COMPANY = '[Company] Select Company';
export const RESET_SELECTED_COMPANY = '[Company] Reset Selected Company';

export class SyncSelectedCompanyState implements Action {
  readonly type = SYNC_SELECTED_COMPANY_STATE;

  constructor(public payload: string) {}
}

export class SelectCompany implements Action {
  readonly type = SELECT_COMPANY;

  constructor(public payload: string) {}
}

export class ResetSelectedCompany implements Action {
  readonly type = RESET_SELECTED_COMPANY;
}

export type SelectCompanyActions = SelectCompany | ResetSelectedCompany | SyncSelectedCompanyState;
